import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const listJobsSlice = createSlice({
  name: 'LIST_JOBS',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// ACTIONS
export const { loading, success, failure } = listJobsSlice.actions;

// REDUCER
export default listJobsSlice.reducer;

// SELECTORS
export const selectIsLoading = (state: RootState) => state.ui.jobs.listJobs.isLoading;
export const selectSuccess = (state: RootState) => state.ui.jobs.listJobs.success;
export const selectError = (state: RootState) => state.ui.jobs.listJobs.error;
